import React from 'react';

export default function Core() {
  return (
    <>
      <h1 className='core'>CORE</h1>
    </>
  );
}
